import React from 'react';
import './ProductShowcase.css';

const features = [
    'Электронные журналы и расписание',
    'Система тестирования с ИИ-проверкой',
    'Мессенджер и push-уведомления',
    'Доступность на Web, iOS, Android, Desktop',
    'ИИ-ассистент и рекомендации'
];

function ProductShowcase() {
    return (
        <section className="showcase" id="product">
            <div className="showcase-inner">
                <div className="showcase-text">
                    <span className="section-label">Наш продукт</span>
                    <h2 className="section-title">Колледж Плюс —<br />образовательная<br />экосистема</h2>
                    <p className="section-sub">
                        Полноценная платформа для управления учебным процессом, разработанная командой AIColl. Используется в реальных учебных заведениях.
                    </p>

                    <ul className="showcase-list">
                        {features.map((feature, index) => (
                            <li key={index}>
                                <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                                {feature}
                            </li>
                        ))}
                    </ul>

                    <a href="/app.html" className="btn btn-accent">
                        Открыть приложение
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                    </a>
                </div>

                <div className="showcase-visual">
                    <div className="app-mock">
                        <div className="app-mock-bar">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
                            <span className="app-mock-bar-title">Колледж Плюс</span>
                        </div>
                        <div className="app-mock-body">
                            <div className="mock-row w-80"></div>
                            <div className="mock-row w-60"></div>
                            <div className="mock-row w-90"></div>
                            <div className="mock-cards">
                                <div className="mock-card"></div>
                                <div className="mock-card"></div>
                                <div className="mock-card"></div>
                                <div className="mock-card"></div>
                            </div>
                            <div className="mock-row w-50" style={{marginTop: '0.5rem'}}></div>
                            <div className="mock-row w-90"></div>
                            <div className="mock-row w-70"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ProductShowcase;